import React from 'react';
import { useRouter } from 'next/router';
import classnames from 'classnames';
import { Box, Button } from '@mui/material';
import { useI18nContext } from '@procore/core-react';
import LocationSearchBar from '../Search/LocationSearchBar';
import { FilterUrlKey } from '../../helpers/filters';
import { useStyles } from './TradeLocationSearch.styles';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';
import { type SeoListType } from '../../types/seo-list-type';

interface TradeLocationSearchProps {
  item: SeoListType;
  filter: FilterUrlKey;
  routeResolver: (
    location: string,
    key: string,
    filter?: FilterUrlKey
  ) => Promise<string>;
}

const TradeLocationSearch = ({
  item,
  filter,
  routeResolver,
}: TradeLocationSearchProps) => {
  const I18n = useI18nContext();
  const classes = useStyles();
  const router = useRouter();
  let { location: queryLocation } = router.query;
  queryLocation = !queryLocation ? '' : queryLocation.toString();
  const [locationString, setLocationString] = React.useState(queryLocation);

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = await routeResolver(
          locationString,
          item.urlKey,
          filter
        );
      }}
    >
      <Box display="flex" alignItems="center" flexDirection="column">
        <LocationSearchBar
          callback={setLocationString}
          classes={classes}
          currentView="COMPANIES"
          inputClass={classnames(classes.searchBar)}
          value={locationString}
        />
        <Box mt={2}>
          <AnalyticsWrappedComponent
            componentType={Button}
            eventText="Clicked Trade Location Search Button"
            eventLabel="Old Hero"
            type="submit"
            className={classnames(classes.searchBar, 'A11yException')}
            data-track-click="Trade Location Search, CTA, Search"
            variant="contained"
            color="secondary"
          >
            {I18n.t('components.trade_location_search.search')}
          </AnalyticsWrappedComponent>
        </Box>
      </Box>
    </form>
  );
};

export default TradeLocationSearch;
